/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ErrorCodes = {
    EntityNotFound: 'ENTITY_NOT_FOUND',
    ContainerAlreadyHasPosition: 'CONTAINER_ALREADY_HAS_POSITION',
    YardBlockDoesNotExist: 'YARD_BLOCK_DOES_NOT_EXIST',
    YardBlockIsNotEmpty: 'YARD_BLOCK_IS_NOT_EMPTY',
    BerthDoesNotExist: 'BERTH_DOES_NOT_EXIST',
    CannotCreateGroupingWithoutSizeAttribute: 'CANNOT_CREATE_GROUPING_WITHOUT_SIZE_ATTRIBUTE',
    CannotCreateGroupingWithoutContainers: 'CANNOT_CREATE_GROUPING_WITHOUT_CONTAINERS',
    FortyContainerSizeBaysRequireTwoBays: 'FORTY_CONTAINER_SIZE_BAYS_REQUIRE_TWO_BAYS',
    BaysCannotBeTransformedToContainerSizeTwenty: 'BAYS_CANNOT_BE_TRANSFORMED_TO_CONTAINER_SIZE_TWENTY',
    YardBlockNameAlreadyExists: 'YARD_BLOCK_NAME_ALREADY_EXISTS',
    AllocationSpaceConflict: 'ALLOCATION_SPACE_CONFLICT',
    PreplanningMixedDangerousAndNonDangerous: 'PREPLANNING_MIXED_DANGEROUS_AND_NON_DANGEROUS',
    PreplanningMixedFullAndEmpties: 'PREPLANNING_MIXED_FULL_AND_EMPTIES',
    PreplanningHasReserved: 'PREPLANNING_HAS_RESERVED',
    PreplanningMixedContainerTurnoverSizes: 'PREPLANNING_MIXED_CONTAINER_TURNOVER_SIZES',
    PreplanningMixedDangerousareaNonDangerouscontainers: 'PREPLANNING_MIXED_DANGEROUSAREA_NON_DANGEROUSCONTAINERS',
    PreplanningMixedNonDangerousareaDangerouscontainers: 'PREPLANNING_MIXED_NON_DANGEROUSAREA_DANGEROUSCONTAINERS',
    YardBlockBayRowNonUnique: 'YARD_BLOCK_BAY_ROW_NON_UNIQUE',
    GeneralCargoLocationHasOccupancy: 'GENERAL_CARGO_LOCATION_HAS_OCCUPANCY',
    GeneralCargoOccupancyDoesNotExist: 'GENERAL_CARGO_OCCUPANCY_DOES_NOT_EXIST',
    PlanningAndUnitPropertiesQuantityMismatch: 'PLANNING_AND_UNIT_PROPERTIES_QUANTITY_MISMATCH',
    WeightClassRangeOverlap: 'WEIGHT_CLASS_RANGE_OVERLAP',
    UnNumberMustBe4CharactersLong: 'UN_NUMBER_MUST_BE_4_CHARACTERS_LONG',
    DgStackingRulesViolationStackingOnTop: 'DG_STACKING_RULES_VIOLATION_STACKING_ON_TOP',
    DgStackingRulesViolationMaxAllowedTier: 'DG_STACKING_RULES_VIOLATION_MAX_ALLOWED_TIER',
    DgSegregationRulesViolation: 'DG_SEGREGATION_RULES_VIOLATION',
    CannotCreateInternalMove: 'CANNOT_CREATE_INTERNAL_MOVE',
    WeightClassSetExists: 'WEIGHT_CLASS_SET_EXISTS',
    CreateWeightClassSetWithoutWeightClasses: 'CREATE_WEIGHT_CLASS_SET_WITHOUT_WEIGHT_CLASSES',
    InvalidId: 'INVALID_ID',
} as const;

export type ErrorCodes = typeof ErrorCodes[keyof typeof ErrorCodes];



